import { type BulmaColor } from '@appsemble/types';
import { getMessageIcon } from '@appsemble/web-utils';
import classNames from 'classnames';
import { type ReactNode } from 'react';

import styles from './index.module.css';
import { Icon } from '../index.js';

interface MessageProps {
  /**
   * The message content.
   */
  readonly children: ReactNode;

  /**
   * Additional class names to assign to the message element.
   */
  readonly className?: string;

  /**
   * The message type.
   */
  readonly color?: BulmaColor;

  /**
   * An optional header for the message.
   */
  readonly header?: ReactNode;
}

export function Message({ children, className, color, header }: MessageProps): ReactNode {
  const icon = getMessageIcon(color);

  return (
    <div className={classNames('message', className, { [`is-${color}`]: color })}>
      {header ? <h6 className="message-header">{header}</h6> : null}
      <div className={classNames('message-body', { [styles.body]: icon })}>
        {icon ? (
          <>
            <Icon
              className={classNames(styles.icon, { 'has-text-danger': color === 'danger' })}
              icon={icon}
            />
            <div className={styles.content}>{children}</div>
          </>
        ) : (
          children
        )}
      </div>
    </div>
  );
}
